import { useField } from "formik";
import { InputControl, InputControlProps } from "formik-chakra-ui";

type InputControlWithParsingProps = InputControlProps & {
  parseInput: (value: string) => string | null;
};

export const InputControlWithParsing = ({
  parseInput,
  inputProps,
  ...props
}: InputControlWithParsingProps) => {
  const [, , helpers] = useField(props.name);
  return (
    <InputControl
      inputProps={{
        onBlur: (e) => {
          const parsedValue = parseInput(e.target.value);
          if (parsedValue !== null) helpers.setValue(parsedValue);
        },
        ...inputProps,
      }}
      {...props}
    />
  );
};
